import { render, staticRenderFns } from "./CadastroProduto.vue?vue&type=template&id=d41a7192&scoped=true"
import script from "./CadastroProduto.vue?vue&type=script&lang=js"
export * from "./CadastroProduto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d41a7192",
  null
  
)

export default component.exports